import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import Landing from './pages/Landing'
import Tutorial from './pages/Tutorial'
import Guide from './pages/Guide'
import Overlay from './pages/Overlay'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/tutorial" element={<Tutorial />} />
        <Route path="/guide" element={<Guide />} />
        <Route path="/overlay/:broadcasterLogin" element={<Overlay />} />
      </Routes>
      <Analytics />
    </BrowserRouter>
  </React.StrictMode>
)
